"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var InlineImageComponent = function (props) {
    var _a = props.attrs, alt = _a.alt, src = _a.src, width = _a.width, height = _a.height, name = _a.name;
    return (react_1.default.createElement("img", { src: src, 
        // @ts-ignore
        name: name, alt: alt || '', width: +width.toFixed(2) || 'auto', height: +height.toFixed(2) || 'auto' }));
};
exports.InlineImageComponent = InlineImageComponent;
var ImageComponent = function (props) {
    var _a;
    var _b = props.attrs, alt = _b.alt, align = _b.align;
    return (react_1.default.createElement("div", { className: "syl-image-wrapper", style: { textAlign: align } },
        react_1.default.createElement("span", { className: classnames_1.default('syl-image-fixer', (_a = {}, _a[align] = align, _a)), style: { display: 'inline-block' } },
            InlineImageComponent(props),
            alt && alt.length > 0 && (react_1.default.createElement("p", { className: "syl-image-caption" }, props.attrs.alt || '')))));
};
exports.ImageComponent = ImageComponent;
//# sourceMappingURL=template.js.map